export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/not-tempered-icon.c4660d82.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};